import { Right } from "constants/right";
import Role from "constants/role";
import { Scope } from "helpers/authenticate";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IWithAgentsState, selectLoggedInAgent } from "store/entities/agents";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ISessionState } from "./reducer";

export interface IWithSessionState {
  features: {
    session: ISessionState;
  };
}

const RIGHTS_TABLE: Record<Role, Record<Right, boolean>> = {
  [Role.Normal]: {
    [Right.ManageAgents]: false,
    [Right.ManageTeams]: false,
    [Right.SeeOtherAgentsTeams]: false,
    [Right.ImportLiveChatAgents]: false,
    [Right.ManageOwnSignature]: true,
    [Right.CreateTickets]: true,
    [Right.ManageTickets]: true,
    [Right.DeleteTickets]: false,
    [Right.CreateCustomViews]: true,
    [Right.SeeCustomViews]: true,
    [Right.SeeSettings]: true,
    [Right.ManageCompanyName]: false,
    [Right.ManageSharedCannedResponses]: true,
    [Right.ManageSharedTags]: false,
    [Right.ManageNotifications]: false,
    [Right.ManageCustomMailboxes]: false,
    [Right.ImportDataFromLiveChat]: false,
    [Right.ManageSubscription]: false,
    [Right.SeeReports]: true,
    [Right.ExportReports]: true,
  },
  [Role.Owner]: {
    [Right.ManageAgents]: true,
    [Right.ManageTeams]: true,
    [Right.SeeOtherAgentsTeams]: true,
    [Right.ImportLiveChatAgents]: true,
    [Right.ManageOwnSignature]: true,
    [Right.CreateTickets]: true,
    [Right.ManageTickets]: true,
    [Right.DeleteTickets]: true,
    [Right.CreateCustomViews]: true,
    [Right.SeeCustomViews]: true,
    [Right.SeeSettings]: true,
    [Right.ManageCompanyName]: true,
    [Right.ManageSharedCannedResponses]: true,
    [Right.ManageSharedTags]: true,
    [Right.ManageNotifications]: true,
    [Right.ManageCustomMailboxes]: true,
    [Right.ImportDataFromLiveChat]: true,
    [Right.ManageSubscription]: true,
    [Right.SeeReports]: true,
    [Right.ExportReports]: true,
  },
  [Role.Viewer]: {
    [Right.ManageAgents]: false,
    [Right.ManageTeams]: false,
    [Right.SeeOtherAgentsTeams]: false,
    [Right.ImportLiveChatAgents]: false,
    [Right.ManageOwnSignature]: false,
    [Right.CreateTickets]: false,
    [Right.ManageTickets]: false,
    [Right.DeleteTickets]: false,
    [Right.CreateCustomViews]: false,
    [Right.SeeCustomViews]: false,
    [Right.SeeSettings]: false,
    [Right.ManageCompanyName]: false,
    [Right.ManageSharedCannedResponses]: false,
    [Right.ManageSharedTags]: false,
    [Right.ManageNotifications]: false,
    [Right.ManageCustomMailboxes]: false,
    [Right.ImportDataFromLiveChat]: false,
    [Right.ManageSubscription]: false,
    [Right.SeeReports]: false,
    [Right.ExportReports]: false,
  },
};

interface IWithAgentsSessionState extends IWithAgentsState, IWithSessionState {}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getAccessToken = (state: IWithSessionState) =>
  state.features.session.user ? state.features.session.user.accessToken : null;

export const getCurrentAgentId = (state: IWithSessionState): string | null =>
  state.features.session.user ? state.features.session.user.id : null;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectCurrentAgentProperties = (state: IWithSessionState) => state.features.session.user?.properties;

export const getAuthKey = (state: IWithSessionState): string | undefined => state.features.session.user?.basicAuthKey;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getRights = (state: IWithSessionState) => state.features.session.rights;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getTagsUsageAllowed = () => true;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getTeamsUsageAllowed = () => true;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getScopes = (state: IWithSessionState) =>
  state.features.session.user ? state.features.session.user.scopes : null;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectTransientFlag = (name: string) => (state: IWithSessionState) =>
  (state.features.session.transientFlags || {})[name] || false;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectIsGhostLogin = (state: IWithSessionState) => state.features.session.isGhostLogin || false;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getTicketsFromOtherTeamsAllowed = (state: IWithAgentsSessionState) => {
  const { permission } = selectLoggedInAgent(state);
  return permission === Role.Owner;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function hasRight(state: IWithSessionState & IWithAgentsSessionState, right: Right) {
  // FIXME: We are bypassing rights management via scopes by now.
  const currentAgent = selectLoggedInAgent(state);

  return RIGHTS_TABLE[currentAgent.permission][right];
}

export function selectCanInviteAgents(state: IWithSessionState & IWithAgentsSessionState): boolean {
  const scopes = getScopes(state);
  return Boolean(
    hasRight(state, Right.ManageAgents) ||
      scopes?.includes(Scope.AccountsRolesHdAllRw) ||
      scopes?.includes(Scope.AccountsRolesHdAllRc)
  );
}

export function selectCanInviteLiveChatAgents(state: IWithSessionState & IWithAgentsSessionState): boolean {
  const scopes = getScopes(state);
  return Boolean(
    hasRight(state, Right.ImportLiveChatAgents) ||
      scopes?.includes(Scope.AccountsRolesHdAllRw) ||
      scopes?.includes(Scope.AccountsRolesHdAllRc)
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectCanAddSeats(state: IWithSessionState & IWithAgentsSessionState) {
  const scopes = getScopes(state);
  return (
    hasRight(state, Right.ManageSubscription) ||
    scopes?.includes(Scope.SubscriptionSeatHdRw) ||
    scopes?.includes(Scope.SubscriptionHdRw)
  );
}
